import React from 'react';
import type { SecuredActionType } from '../../../components/ActionType';
import { SidePanelToolbar } from '../../../components/layout/SidePanelToolbar';
import type { SidePanelDeclaration, SidePanelSubject } from '../../types';
import { useSidePanelCommands } from '../hooks/useSidePanelCommands';
import { useSidePanelState } from '../hooks/useSidePanelState';

export type SidePanelToolbarActionsProps = {
    declarations: readonly SidePanelDeclaration[];
    subject: SidePanelSubject | null;
};

export function SidePanelToolbarActions({ declarations, subject }: SidePanelToolbarActionsProps) {
    const commands = useSidePanelCommands();
    const session = useSidePanelState((state) => state.session);

    const securedActions = declarations.map<SecuredActionType>(({ definition, hidden, enabled }) => ({
        icon: definition.icon,
        label: typeof definition.label === 'string' ? definition.label : <>{definition.label}</>,
        hidden,
        disabled: (definition.kind === 'entity' && !subject) || Boolean(enabled && !enabled(subject)),
        selected: session?.panelId === definition.id && session.subject === subject,
        securityAction: definition.affordancePermission?.securityAction,
        featureName: definition.affordancePermission?.featureName,
        entityName: subject?.entityName,
        entitySecurity: subject?.security,
        onClick: () => {
            commands.toggle(definition.id, { subject: subject ?? undefined });
        }
    }));

    return <SidePanelToolbar securedActions={securedActions} />;
}
